require('./../Css/style.css');
import { YoutubePlay } from 'youtube-video-plugin';

function init() {
    initYoutubeVideo();  
}

function initYoutubeVideo() {
    const selector = 'js-youtube-video';
    const elem = document.querySelector('.js-youtube-video');
    if (!elem) {
        return;
    }

    YoutubePlay.run({
        className: selector,
        mute: 1,
        autoplay: 1,
        controls: 0,
        showinfo: 0,
        loop: 1,
        width: 600,
        height: 400
    });       
}

export default init;


// WEBPACK FOOTER //
// ./uPortal/Core/Panels/HeroPanel/Js/index.js